module.exports = __webpack_public_path__ + "static/media/XMT.0401029e.svg";